import * as Lucide from "lucide-react";

// Generic icon resolver from a string name (lucide-react).
export const Icon = ({ name, className = "", strokeWidth = 1.5, ...props }) => {
  const Cmp = Lucide[name] || Lucide.Circle;
  return <Cmp className={className} strokeWidth={strokeWidth} {...props} />;
};

export default Icon;
